import React from "react";

import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";

import { getCamelCaseWord } from "../utils/functions";

/* ============================================================================
<FilterDropDown/>
============================================================================= */
const FilterDropDown = ({ data, value, placeholder, onChange }) => {
  const handleSelect = (selectedValue) => {
    onChange(selectedValue)
  };

  return (
    <PopupState>
      {(popupState) => (
        <>
          <Button
            variant="outlined"
            endIcon={<KeyboardArrowDown />}
            sx={{
              color: "#848694",
              borderColor: "divider",
              textTransform: "none",
              fontStyle: "Outfit",
              py: 1.5,
              px: { xs: 3, lg: 1 },
              fontSize: { xs: '.7rem', lg: '.8rem' },
              borderRadius: '7px',
              "&:hover": {
                borderColor: "primary.main",
              },
            }}
            {...bindTrigger(popupState)}
          >
            {value || placeholder || 'Stage'}
          </Button>
          <Menu {...bindPopover(popupState)}>
            {data?.map((d) => (
              <MenuItem
                key={d}
                sx={{ fontSize: '14px', fontFamily: 'Outfit' }}
                onClick={() => {
                  handleSelect(d);
                  popupState.close()
                }}>
                {getCamelCaseWord(d)}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
};


/* Export
============================================================================= */
export default FilterDropDown
